import PropTypes from 'prop-types';
import {
  Locked as LockedIcon,
  Article as ArticleIcon,
  LmsBook as LmsBookIcon,
  LmsEditSquare as LmsEditSquareIcon,
  LmsVideocam as LmsVideocamIcon,
} from '@openedx/paragon/icons';

export const UNIT_ICON_TYPES = {
  video: 'video',
  problem: 'problem',
  vertical: 'vertical',
  lock: 'lock',
  other: 'other',
};

const UnitIcon = ({ type, ...props }) => {
  const iconMap = {
    [UNIT_ICON_TYPES.video]: {
      default: LmsVideocamIcon,
    },
    [UNIT_ICON_TYPES.problem]: {
      default: LmsEditSquareIcon,
    },
    [UNIT_ICON_TYPES.vertical]: ArticleIcon,
    [UNIT_ICON_TYPES.lock]: LockedIcon,
    [UNIT_ICON_TYPES.other]: {
      default: LmsBookIcon,
    },
  };

  let Icon = iconMap[type || UNIT_ICON_TYPES.other];

  if (typeof Icon === 'object') {
    Icon = iconMap[type || UNIT_ICON_TYPES.other]?.default;
  }

  return (
    <Icon {...props} className="text-gray-700" />
  );
};

UnitIcon.propTypes = {
  type: PropTypes.oneOf(Object.keys(UNIT_ICON_TYPES)).isRequired,
};

export default UnitIcon;
